import {Link} from "react-router-dom";


export default function DepartmentItem ({item}){

    return (
        <div className={'col-md-3 col-4  my-1'}>
            <Link to={`/departments/${item.id}`} class={'anchor'}>
                <div className="flex-column justify-content-center align-items-center">
                    <div className="category-item" style={{backgroundImage:`url("${item.img}")`}}></div>
                    <div className="category-title text-center">{item.name}</div>
                </div>

            </Link>
        </div>

    )
}